import api from '../config/api';
import { getFilePreviewUrl } from '../utils/fileToken';

const clientService = {
  /**
   * Get all clients
   */
  getClients: async () => {
    const response = await api.get('/clients');
    return response.data;
  },

  /**
   * Create a new client
   */
  createClient: async (clientData) => {
    const response = await api.post('/clients', clientData);
    return response.data;
  },

  /**
   * Update a client
   */
  updateClient: async (id, clientData) => {
    const response = await api.put(`/clients/${id}`, clientData);
    return response.data;
  },

  /**
   * Delete a client
   */
  deleteClient: async (id) => {
    const response = await api.delete(`/clients/${id}`);
    return response.data;
  },

  /**
   * Delete a client document
   */
  deleteDocument: async (id, docId) => {
    const response = await api.delete(`/clients/${id}/documents/${docId}`);
    return response.data;
  },

  /**
   * Upload client document
   */
  uploadDocument: async (id, formData) => {
    const response = await api.post(`/clients/${id}/documents`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  /**
   * Upload client signature image
   */
  uploadSignature: async (id, formData) => {
    const response = await api.post(`/clients/${id}/signature`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  /**
   * Delete client signature
   */
  deleteSignature: async (id) => {
    const response = await api.delete(`/clients/${id}/signature`);
    return response.data;
  },

  /**
   * Get client signature URL
   */
  getSignatureUrl: async (clientId) => {
    return getFilePreviewUrl(`/clients/${clientId}/signature`);
  }
};

export default clientService;
